<template>
    <div class="drawer">
        <el-drawer size="1000px" title="提成规划" :visible.sync="drawerStatus" @close="handleClose">
            <div style="padding-bottom: 90px" class="drawerRow">
                <el-row class="row">
                    <el-button @click="SetList" size="20" type="warning" plain>配置历史</el-button>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">商品配置</div> <el-button @click="addItem" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.goodsConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">医疗配置</div> <el-button @click="addItem1" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.medicalConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem1(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">洗澡配置</div> <el-button @click="addItem2" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.washConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem2(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">美容配置</div> <el-button @click="addItem3" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.cosmetologyConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem3(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">活体配置</div> <el-button @click="addItem4" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.petConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem4(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">跟诊配置</div> <el-button @click="addItem5" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.followMedicalConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem5(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">寄养配置</div> <el-button @click="addItem6" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.fosterConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem6(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">套餐卡配置</div> <el-button @click="addItem7" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.packageCardConfig" :key="index">
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem7(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">宠物奖金配置</div> <el-button @click="addItem8" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="line">

                            <div class="lineL">12个月的活体奖励:</div>
                            <el-input-number v-model.number="datas.petBonusConfig.specialRatio" @change="handleChange"
                                :min="0" :max="100000000" label="描述文字"></el-input-number>

                        </div>

                        <div class="line">
                            <div class="lineL">6-12个月的活体奖励:</div>
                            <el-input v-model.number="datas.petBonusConfig.bigPetRatio" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>

                        </div>
                        <div class="line">

                            <div class="lineL">12个月的活体奖励:</div>
                            <el-input v-model.number="datas.petBonusConfig.adultRatio" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>

                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.petBonusConfig.spotsConfig" :key="index">
                            <div class="drawerComT">现货宠物提成:</div>
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem8(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">宠物奖金配置</div> <el-button @click="addItem9" plain 
                                size="20" type="warning">新建</el-button>
                        </div>
                        <div class="drawerCom" v-for="(item, index) in  datas.petBonusConfig.forwardConfig" :key="index">
                            <div class="drawerComT">期货宠物提成:</div>
                            <el-input v-model.number="item.saleMinAmount" size="20" type="number"
                                placeholder="请输入最低金额"></el-input>
                            <div>-</div>
                            <el-input v-model.number="item.saleMaxAmount" size="20" type="number"
                                placeholder="请输入最高金额"></el-input>
                            <el-input-number v-model.number="item.ratio" @change="handleChange" :min="0" :max="100000000"
                                label="描述文字"></el-input-number>
                            <el-button @click="deleteItem9(item, index)" size="20" type="warning" plain>删除</el-button>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">自有宠物洗澡狗</div>
                            <el-input v-model.number="datas.ownPetDogWash" size="20" type="number"
                                placeholder="请输入金额"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">自有宠物洗澡猫</div>
                            <el-input v-model.number="datas.ownPetCatWash" size="20" type="number"
                                placeholder="请输入金额"></el-input>

                        
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">百天医疗 补助</div>
                            <el-input v-model.number="datas.medicalAid" size="20" type="number"
                                placeholder="请输入金额"></el-input>
                           
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">DR补助</div>
                            <el-input v-model.number="datas.dr" size="20" type="number"
                                placeholder="请输入金额"></el-input>
                          
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div class="drawerView">
                            <div class="drawerViewT">接送补助</div>
                            <el-input v-model.number="datas.petPickUp" size="20" type="number"
                                placeholder="请输入金额"></el-input>
                            
                        </div>
                    </el-col>
                </el-row>
                <div style="height: 40px; width: 100%"></div>
                <div class="btnBox">
                    <div class="btnItem" @click="handleClose">取消</div>
                    <div class="btnItem submit" @click="submit_check">确定</div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            drawerStatus: true,
            datas: {
                goodsConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                washConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                medicalConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                cosmetologyConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                petConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                followMedicalConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                fosterConfig: [
                    {
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }
                ],
                packageCardConfig: [{
                    saleMinAmount: 1,
                    saleMaxAmount: 10000,
                    ratio: 0
                }],
                petBonusConfig: {
                    specialRatio: 0,
                    bigPetRatio: 0,
                    adultRatio: 0,
                    spotsConfig: [{
                        saleMinAmount: 1,
                        saleMaxAmount: 10000,
                        ratio: 0
                    }],
                    forwardConfig: [
                        {
                            saleMinAmount: 1,
                            saleMaxAmount: 10000,
                            ratio: 0
                        }
                    ]
                },
                ownPetDogWash: '',
                ownPetCatWash: '',
                medicalAid: '',
                dr: '',
                petPickUp: '',
            },
        };
    },
    computed: {},
    props: {},

    mounted() {
        this.getDatas()

    },
    methods: {
        // 配置历史
        SetList(){
        this.$router.push({
        path:
          "/Newmoneypk/List",
        });
        },
        // 商品添加
        addItem() {
            this.datas.goodsConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem(item, Index) {
            console.log(Index)
            this.datas.goodsConfig.splice(Index, 1)
        },
        addItem1() {
            this.datas.medicalConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem1(item, Index) {
            console.log(Index)
            this.datas.medicalConfig.splice(Index, 1)
        },
        addItem2() {
            this.datas.washConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem2(item, Index) {
            console.log(Index)
            this.datas.washConfig.splice(Index, 1)
        },
        addItem3() {
            this.datas.cosmetologyConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem3(item, Index) {
            console.log(Index)
            this.datas.cosmetologyConfig.splice(Index, 1)
        },
        addItem4() {
            this.datas.petConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem4(item, Index) {
            console.log(Index)
            this.datas.petConfig.splice(Index, 1)
        },
        addItem5() {
            this.datas.followMedicalConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem5(item, Index) {
            console.log(Index)
            this.datas.followMedicalConfig.splice(Index, 1)
        },
        addItem6() {
            this.datas.fosterConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem6(item, Index) {
            console.log(Index)
            this.datas.fosterConfig.splice(Index, 1)
        },
        addItem7() {
            this.datas.packageCardConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem7(item, Index) {
            console.log(Index)
            this.datas.packageCardConfig.splice(Index, 1)
        },
        addItem8() {
            this.datas.petBonusConfig.spotsConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem8(item, Index) {
            console.log(Index)
            this.datas.petBonusConfig.spotsConfig.splice(Index, 1)
        },
        addItem9() {
            this.datas.petBonusConfig.forwardConfig.push({
                saleMinAmount: '',
                saleMaxAmount: '',
                ratio: 0
            })
        },
        // 商品删除
        deleteItem9(item, Index) {
            console.log(Index)
            this.datas.petBonusConfig.forwardConfig.splice(Index, 1)
        },
        // 计数器
        handleChange(value) {
            console.log(value);
        },
        handleClose() {
            this.$emit("submit", { type: "close" });
        },
        // 获取详情
        getDatas() {
            this.$http
                .get(
                    process.env.VUE_APP_zichan +
                    "/api/Performance/GetStaffPerformanceConfig")
                .then((res) => {
                    if (res.code == 0) {
                        this.datas = res.data;
                        console.log(this.datas, "数据");
                    }
                });
        },
        // 提交
        submit_check() {
            let params = {
                medicalConfig: this.datas.medicalConfig,
                goodsConfig: this.datas.goodsConfig,
                cosmetologyConfig: this.datas.cosmetologyConfig, //美容
                petConfig: this.datas.petConfig,
                followMedicalConfig: this.datas.followMedicalConfig,
                fosterConfig: this.datas.fosterConfig,
                packageCardConfig: this.datas.packageCardConfig,
                ownPetDogWash: this.datas.ownPetDogWash,
                ownPetCatWash: this.datas.ownPetCatWash,
                medicalAid: this.datas.medicalAid,
                dr: this.datas.dr,
                petPickUp: this.datas.petPickUp,
                washConfig:this.datas.washConfig,
                petBonusConfig:this.datas.petBonusConfig
            };
            console.log(params, "123321");

            this.$http
                .post(
                    process.env.VUE_APP_zichan + "/api/Performance/UpdateStaffPerformanceConfig",
                    params
                )
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "设置成功",
                            type: "success",
                        });
                        this.$emit("submit", { type: "success" });
                    }
                });
        },

    },
};
</script>
  
<style scoped lang="scss">
.drawerRow {
    width: 100%;
    height: 100vh;
    overflow-x: auto;
}

.row {
    padding: 20px 20px 0 20px;
    float: none;

    .drawerView {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .drawerViewT {
        font-size: 20px;
        font-weight: 700;
        margin-right: 20px;
    }

    .drawerCom {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 10px 0;
    }

    .el-input {
        width: 160px;
    }
    .line{
        display: flex;
        align-items: center;
        margin: 10px 0;
    }
    .lineL{
        margin-right: 20px;
    }

}

.btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;

    .btnItem {
        text-align: center;
        width: 100%;
        background-color: #d6d6d6;
        cursor: pointer;

        &.submit {
            background-color: $mainColor;
        }
    }
}</style>
  